import i18next from 'i18next';

import {
  COOKIE_SETTINGS,
  LCZ_STRINGS,
} from '../constants';
import { DEV_ERRORS } from '../constants/local';
import CookieManager from '../CookieManager';

const manager = CookieManager;

const requiredProps = ['storageKey'];

const {
  FUNCTIONALITY,
  ANALYTICS,
} = COOKIE_SETTINGS;

export const getGDPRSetting = (key) => manager.getGDPRSetting(key);

/**
 * Check if GDPR setting is enabled
 * @param {string} setting GDPR setting
 * @returns {boolean}
 */
const isGDPRSettingEnabled = (setting) => {
  if (!manager.initialized) throw new Error(DEV_ERRORS.NOT_INITIALIZED);
  if (!manager.active) return true;

  const value = getGDPRSetting(setting);
  const defaultValue = manager.settings[setting];

  return value === undefined ? defaultValue : value;
};

export const isGDPRFunctionalityEnabled = () => isGDPRSettingEnabled(FUNCTIONALITY);

// Use in siteplus-website
export const isGDPRAnalyticsEnabled = () => isGDPRSettingEnabled(ANALYTICS);

// Use in siteplus-website
export const openSettingsPopup = () => {
  if (!manager.noticeRef) {
    console.warn(
      'Can`t open cookie setting popup because parent component isn`t rendered'
    );

    return;
  }

  manager.noticeRef.toggleModal(true)();
};

// TODO: temporally hack before we figure out what to do with initialization during Stage 2
const init = (config) => {
  if (manager.initialized) {
    throw new Error(DEV_ERRORS.ALREADY_INITIALIZED);
  }

  const missedProps = requiredProps.filter((prop) => !config[prop]);

  if (missedProps.length > 0) {
    throw new Error(DEV_ERRORS.CONFIG_IS_REQUIRED(missedProps));
  }

  manager.initialize(config);
};

/**
 * Create function for generating l10n strings
 * @param prefix - prefix to us in translation
 * @returns {function(*=): {}}
 */
export const createCookieNoticeLczStrings = (prefix = '') => (vars = {}) => Object.keys(LCZ_STRINGS)
  .reduce((acc, key) => {
    // eslint-disable-next-line no-param-reassign
    acc[key] = i18next.t(`${prefix}${key}`, vars);

    return acc;
  }, {});

export default init;
